import * as React from "react";
import {Modal, Button,message} from "antd";
import { connect } from "react-redux";


interface IVerifyProps {
  id:any;
  verify:any;
  label: any;
  style: any;
  status:any;
  getOrderDetails:any;
  submit:any;
  data:any;
}

class Verify extends React.Component<IVerifyProps, any> {
  state = {
    visible:false,
    content:'',
  };
  constructor(props: IVerifyProps) {
    super(props);
  }
  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }
  submitV = () =>{
      const param: any = {
        id: this.props.id,
        order_status:this.props.status,
      }; 
      this.props.verify({
        ...param,
        callback: (data) => {
          if(data.res.code == 3001){
            this.setState({
              visible: true,
            });
          }else if(data.res.code != 1001){
            const params: any = {
              id: this.props.id
            }; 
            this.props.getOrderDetails({
               ...params,
               callback: () => {
               }
             });
          }
        }
       }); 
  }

  onOk= () =>{
    const param: any = {
      id: this.props.id,
      order_status:this.props.status,
      two_push:1,
    }; 
    this.props.verify({
      ...param,
      callback: (data) => {
        if(data.res.code != 1001){
          const params: any = {
            id: this.props.id
          }; 
          this.props.getOrderDetails({
             ...params,
             callback: () => {
             }
           });
        }
      }
     }); 
  }

  submit = () => {
    const param = this.props.data;
    this.props.submit({
      ...param,
      callback: (data) => {
        if(data.code=='1001'){
          if(data.data instanceof Array){
            const info = data.data.map((item,key) =>{
                return(<p key={key}>{item}</p> );
            });
            message.error(info);
           }
        }else{
          this.submitV();
        }
      }
     });    
      //console.log(this.props.data);
  }

  render() {
    return (
      <React.Fragment>
      <Button type="primary" style={{...this.props.style,paddingLeft: "28",paddingRight: "28", backgroundColor: "#2b9fbd" }}  onClick={this.submit}><div>{this.props.label}</div></Button>
      <Modal maskClosable={false} onOk={this.onOk} onCancel={this.handleCancel} title="继续审核"  visible={this.state.visible}  width="auto" centered={true}>
          <div className="abnormal">
           还有没有合并的订单，是否继续审核？
          </div>
      </Modal>  
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
  status: state.orderDetails.status,
  data: state.orderDetails.data,
});

const mapDispatch = dispatch => {
  return {
    sendMail:dispatch.orderDetails.sendMail,
    verify:dispatch.orderDetails.verify,
    getOrderDetails:dispatch.orderDetails.getOrderDetails,
    submit:dispatch.orderDetails.submit,
  };
};

export default connect(
  mapState ,
  mapDispatch
)(Verify);
